import main from '@/main.js'


/**
 * 时间格式化
 * @param format
 * @returns {*}
 */
Date.prototype.format = function (format) {
  var args = {
    "M+": this.getMonth() + 1,
    "d+": this.getDate(),
    "h+": this.getHours(),
    "m+": this.getMinutes(),
    "s+": this.getSeconds(),
    "q+": Math.floor((this.getMonth() + 3) / 3),  //quarter
    "S": this.getMilliseconds()
  };
  if (/(y+)/.test(format))
    format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var i in args) {
    var n = args[i];
    if (new RegExp("(" + i + ")").test(format))
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? n : ("00" + n).substr(("" + n).length));
  }
  return format;
};

/**
 * 获得星期几
 * @returns {string}
 */
Date.prototype.getWeekDay = function () {
  switch (this.getDay()) {
    case 0:
      return "日";
      break;
    case 1:
      return "一";
      break;
    case 2:
      return "二";
      break;
    case 3:
      return "三";
      break;
    case 4:
      return "四";
      break;
    case 5:
      return "五";
      break;
    case 6:
      return "六";
      break;
  }
};


/**
 * 时间戳格式化函数
 * @param  {string} format    格式
 * @param  {int}    timestamp 要格式化的时间 默认为当前时间
 * @return {string}           格式化的时间字符串
 */
function formatDateTime(format, timestamp) {//Y-m-d h:i:s
  if (timestamp == null) return null;
  var a, jsdate = ((timestamp) ? new Date(timestamp * 1000) : new Date());
  var pad = function (n, c) {
    if ((n = n + "").length < c) {
      return new Array(++c - n.length).join("0") + n;
    } else {
      return n;
    }
  };
  var txt_weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  var txt_ordin = {1: "st", 2: "nd", 3: "rd", 21: "st", 22: "nd", 23: "rd", 31: "st"};
  var txt_months = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  var f = {
    // Day
    d: function () {
      return pad(f.j(), 2)
    },
    D: function () {
      return f.l().substr(0, 3)
    },
    j: function () {
      return jsdate.getDate()
    },
    l: function () {
      return txt_weekdays[f.w()]
    },
    N: function () {
      return f.w() + 1
    },
    S: function () {
      return txt_ordin[f.j()] ? txt_ordin[f.j()] : 'th'
    },
    w: function () {
      return jsdate.getDay()
    },
    z: function () {
      return (jsdate - new Date(jsdate.getFullYear() + "/1/1")) / 864e5 >> 0
    },

    // Week
    W: function () {
      var a = f.z(), b = 364 + f.L() - a;
      var nd2, nd = (new Date(jsdate.getFullYear() + "/1/1").getDay() || 7) - 1;
      if (b <= 2 && ((jsdate.getDay() || 7) - 1) <= 2 - b) {
        return 1;
      } else {
        if (a <= 2 && nd >= 4 && a >= (6 - nd)) {
          nd2 = new Date(jsdate.getFullYear() - 1 + "/12/31");
          return date("W", Math.round(nd2.getTime() / 1000));
        } else {
          return (1 + (nd <= 3 ? ((a + nd) / 7) : (a - (7 - nd)) / 7) >> 0);
        }
      }
    },

    // Month
    F: function () {
      return txt_months[f.n()]
    },
    m: function () {
      return pad(f.n(), 2)
    },
    M: function () {
      return f.F().substr(0, 3)
    },
    n: function () {
      return jsdate.getMonth() + 1
    },
    t: function () {
      var n;
      if ((n = jsdate.getMonth() + 1) == 2) {
        return 28 + f.L();
      } else {
        if (n & 1 && n < 8 || !(n & 1) && n > 7) {
          return 31;
        } else {
          return 30;
        }
      }
    },

    // Year
    L: function () {
      var y = f.Y();
      return (!(y & 3) && (y % 1e2 || !(y % 4e2))) ? 1 : 0
    },
    //o not supported yet
    Y: function () {
      return jsdate.getFullYear()
    },
    y: function () {
      return (jsdate.getFullYear() + "").slice(2)
    },

    // Time
    a: function () {
      return jsdate.getHours() > 11 ? "pm" : "am"
    },
    A: function () {
      return f.a().toUpperCase()
    },
    B: function () {
      // peter paul koch:
      var off = (jsdate.getTimezoneOffset() + 60) * 60;
      var theSeconds = (jsdate.getHours() * 3600) + (jsdate.getMinutes() * 60) + jsdate.getSeconds() + off;
      var beat = Math.floor(theSeconds / 86.4);
      if (beat > 1000) beat -= 1000;
      if (beat < 0) beat += 1000;
      if ((String(beat)).length == 1) beat = "00" + beat;
      if ((String(beat)).length == 2) beat = "0" + beat;
      return beat;
    },
    g: function () {
      return jsdate.getHours() % 12 || 12
    },
    G: function () {
      return jsdate.getHours()
    },
    h: function () {
      return pad(f.g(), 2)
    },
    H: function () {
      return pad(jsdate.getHours(), 2)
    },
    i: function () {
      return pad(jsdate.getMinutes(), 2)
    },
    s: function () {
      return pad(jsdate.getSeconds(), 2)
    },
    //u not supported yet

    // Timezone
    //e not supported yet
    //I not supported yet
    O: function () {
      var t = pad(Math.abs(jsdate.getTimezoneOffset() / 60 * 100), 4);
      if (jsdate.getTimezoneOffset() > 0) t = "-" + t; else t = "+" + t;
      return t;
    },
    P: function () {
      var O = f.O();
      return (O.substr(0, 3) + ":" + O.substr(3, 2))
    },
    //T not supported yet
    //Z not supported yet

    // Full Date/Time
    c: function () {
      return f.Y() + "-" + f.m() + "-" + f.d() + "T" + f.h() + ":" + f.i() + ":" + f.s() + f.P()
    },
    //r not supported yet
    U: function () {
      return Math.round(jsdate.getTime() / 1000)
    }
  };
  return format.replace(/[\]?([a-zA-Z]/g, function (t, s) {
    return f[t]();
  });
}


/**
 * @return {string}
 */
function GetQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  } else {
    return null;
  }
}


function NavigationPage(params) {
  var query = (params.query == null ? {} : params.query);
  var path = params.path;
  var pathQuery = "";
  var autofill = function (key, val) {//自动拼接参数
    if (key == null || key === '' || val == null || val === '') return true;
    if (pathQuery.indexOf('?') === -1) {
      pathQuery += "?" + key + "=" + encodeURIComponent(val);
    } else {
      pathQuery += "&" + key + "=" + encodeURIComponent(val);
    }
  };
  if (query == null) query = {};
  //如果path参数里面有参数的
  if (path.indexOf('?') > -1) {
    var par = path.substring(path.indexOf("?"));
    var pars = urlParse(par);
    each(pars, function (key) {
      query[key] = this;
    });
    //去掉path参数
    path = path.substring(0, path.indexOf("?"));
  }
  //参数
  if (!query) query = {};
  each(query, function (key) {
    if (key === 'SysUserRole_id') return true;
    autofill(key, this);
  });
  //销售传参
  if (query['SysUserRole_id'] != null) {
    if (query['SysUserRole_id'] !== -1) {
      autofill('SysUserRole_id', query['SysUserRole_id']);
    }
  } else {
    var gg = main.$route.query.SysUserRole_id;
    if (gg != null) {
      autofill('SysUserRole_id', gg);
    }
  }
  // window.location.href = path + pathQuery;
  if (path.substring(0, 4) === 'http' || path.substring(0, 2) === '//') {
    window.open(path + pathQuery);
  } else {
    main.$router.push({
      path: path + pathQuery,
      query: {}
    }).then(res => {
      console.log(res);
    }).catch(err => {
      console.log(err);
    });
  }


}


/**
 * 时间转时间戳
 * @param date
 * @returns {Date}
 * @constructor
 */
function StrToTime(date) {
  date = date.substring(0, 19);
  date = date.replace(/-/g, '/');
  return new Date(date);
}


/**
 * @return {string}
 */
function GetShowMoney(s) {
  var tt = Number(s).toFixed(2);
  var tts = tt.split(".");
  if (tts[1] === "00") {
    return tts[0];
  } else {
    return tt;
  }
}

/**
 * 获得团队报价
 * @return {string}
 */
function GetTeamPrice(pgobj, typ) {
  var price = "-";
  each(pgobj, function () {
    if (this["Enabled"] !== 1) return true;
    each(this["PriceList"], function () {
      var t_price = this;
      if (t_price["Enabled"] !== 1) return true;
      if (t_price["Type"] === "A00" && typ === "dr") price = GetShowMoney(t_price["SellPrice"]);
      if (t_price["Type"] === "A01" && typ === "xh") price = GetShowMoney(t_price["SellPrice"]);
      //游轮
      if (t_price["Type"] === "A10") price = GetShowMoney(t_price["SellPrice"]);
      if (t_price["Type"] === "A11") price = GetShowMoney(t_price["SellPrice"]);
      if (t_price["Type"] === "A12") price = GetShowMoney(t_price["SellPrice"]);
      if (t_price["Type"] === "A13") price = GetShowMoney(t_price["SellPrice"]);
      //河轮
      if (t_price["Type"] === "A20") price = GetShowMoney(t_price["SellPrice"]);
      if (t_price["Type"] === "A21") price = GetShowMoney(t_price["SellPrice"]);
      if (t_price["Type"] === "A22") price = GetShowMoney(t_price["SellPrice"]);
      if (t_price["Type"] === "A23") price = GetShowMoney(t_price["SellPrice"]);
      if (t_price["Type"] === "A24") price = GetShowMoney(t_price["SellPrice"]);
      if (price !== '-') {
        return false;
      }
    });
  });
  return price;
}


function each(object, callback) {
  var type = (function () {
    switch (object.constructor) {
      case Object:
        return 'Object';
        break;
      case Array:
        return 'Array';
        break;
      case NodeList:
        return 'NodeList';
        break;
      default:
        return 'null';
        break;
    }
  })();
  // 为数组或类数组时, 返回: index, value
  if (type === 'Array' || type === 'NodeList') {
    // 由于存在类数组NodeList, 所以不能直接调用every方法
    [].every.call(object, function (v, i) {
      return callback.call(v, i, v) === false ? false : true;
    });
  }
  // 为对象格式时,返回:key, value
  else if (type === 'Object') {
    for (var i in object) {
      if (callback.call(object[i], i, object[i]) === false) {
        break;
      }
    }
  }
};


export default {
  formatDateTime,
  each,
  StrToTime,
  NavigationPage,
  GetQueryString,
  GetTeamPrice,
  GetShowMoney,
}





// WEBPACK FOOTER //
// ./src/utils/index.js